import React from 'react';
import { NavLink } from 'react-router-dom';

const WaterDrop = () => (
  <svg className="brand-icon" width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="#1F4E79"
      d="M12 2.1C12 2.1 5.2 9.4 5.2 14.3a6.8 6.8 0 0 0 13.6 0C18.8 9.4 12 2.1 12 2.1z"
    />
  </svg>
);

const Header = ({ user, onLogout }) => (
  <header className="app-header">
    <NavLink to="/" className="brand">
      <WaterDrop />
      <span>Flood Center</span>
    </NavLink>
    <nav className="header-nav" aria-label="Site">
      <NavLink to="/how-it-works">How it works</NavLink>
      <NavLink to="/alerts">Get alerts</NavLink>
      {user && (
        <button type="button" className="text-button" onClick={onLogout}>
          Sign out
        </button>
      )}
    </nav>
  </header>
);

export default Header;
